// This file is auto-generated by ./scripts/parse-webdata.js
// Do not edit this file directly. Instead, edit the Markdown files in src/data/blog/{locale}/

const allBlogPosts = {
    en: [
        {
            date: new Date("2026-04-03"),
            title: "Contact with the Startup Gravix ",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Cosmic Shores has begun discussions with Gravix, a local startup aiming to develop return flights for microgravity experiments, among other things. Preliminary exploration is underway to identify airfields in Argentina that could potentially support the Gravix mission.</p>\n",
        },
        {
            date: new Date("2026-03-20"),
            title: "Colombia Exploration",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Discussions have begun to explore potential sites for a spaceport in Colombia.</p>\n",
        },
        {
            date: new Date("2026-03-01"),
            title: "Rocha Spaceport",
            subtitle: "Architectural firm GVV",
            image: "rochagvv.png",
            type: "long",
            slug: "rocha-gvv",
            bodyHtml: "<p>Conceptual development of the spaceport in Rocha, Uruguay, continues through a collaborative effort with the architectural firm García Vogliolo y Vitale. The proposal integrates criteria of technical functionality, environmental sustainability, and integration into the local landscape, addressing both operational needs and elements that foster connections with the surrounding environment and the community. A site plan was developed, outlining the various designated areas and the infrastructure associated with each, along with a new land-use plan.</p>\n",
        },
        {
            date: new Date("2026-02-25"),
            title: "Regional expansion of contacts",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Cosmic Shores' initial network in the region is taking shape, with ties and focal points being established in Uruguay, Chile, Ecuador, Costa Rica, and the Dominican Republic.</p>\n",
        },
        {
            date: new Date("2026-02-06"),
            title: "The Cosmic Shores CORP",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>The company is established as a corporation in the State of Florida, USA</p>\n",
        },
        {
            date: new Date("2025-10-20"),
            title: "Global strategy",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Today, different strategic approaches are being studied in different parts of the world.</p>\n",
        },
        {
            date: new Date("2025-09-15"),
            title: "Ecuador",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Exploration of activities in Ecuador began.</p>\n",
        },
        {
            date: new Date("2025-09-01"),
            title: "Incorporation of GVV Studio",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>The architectural firm García Vogliolo y Vitale has joined the team to move forward with the development of spaceport infrastructure.</p>\n",
        },
        {
            date: new Date("2025-09-01"),
            title: "Spaceport in Rocha",
            subtitle: "Through a collaboration with HAL Studio",
            image: "render-87.jpg",
            type: "long",
            slug: "puerto-espacial-rocha",
            bodyHtml: "<p>In September 2025, we began developing a spaceport for the Rocha Department in Uruguay.</p>\n<p>It must be adapted to the municipality's requirements, given that there is a nature reserve near the chosen site.</p>\n<p>We began by planning the site and estimating the minimum infrastructure required, which will enable us to carry out a cost analysis.</p>\n",
        },
        {
            date: new Date("2025-08-19"),
            title: "Participation in the 50th Anniversary CIDA-E",
            subtitle: "Cosmic Shores goes to Uruguay",
            image: "cida-e.png",
            type: "long",
            slug: "50-aniversario-cida-e",
            bodyHtml: "<p>Cosmic Shores participates in the meeting organized by the Uruguayan Center for Aeronautical and Space Research and Outreach, at its event commemorating its 50th anniversary.</p>\n<p>At this meeting, key contacts were made with leading figures in the sector in Uruguay.</p>\n",
        },
        {
            date: new Date("2025-01-01"),
            title: "Strategic Partner",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Hugo A. Larotonda's HAL Studio joined as a new strategic partner.</p>\n",
        },
        {
            date: new Date("2024-12-01"),
            title: "Argentina",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>The possibility of developing Argentina's space ports began to be explored.</p>\n",
        },
        {
            date: new Date("2024-06-01"),
            title: "Planning",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>The Strategic Business Plan (SBP) and the first General Business Plan (GBP) were created.</p>\n",
        },
        {
            date: new Date("2024-05-01"),
            title: "Cosmic Shores SpacePorts is Founded",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>The name of the company is chosen.</p>\n",
        },
        {
            date: new Date("2024-04-01"),
            title: "Birth of an Idea",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>The idea of forming a company linked to spaceports emerged as a spin-off from WITMO and SOGi.</p>\n",
        },
    ],
    es: [
        {
            date: new Date("2026-04-03"),
            title: "Contactos con la misión Gravix",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Cosmic Shores inicia conversaciones con Gravix, una startup local que busca desarrollar vuelos de recuperación para experimentos en microgravedad, entre otras cosas. Se está explorando de manera preliminar las pistas potencialmente compatibles con la misión Gravix en Argentina.</p>\n",
        },
        {
            date: new Date("2026-03-20"),
            title: "Exploraciones en Colombia",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se inician tratativas para explorar posibilidades de emplazamiento de un Espaciopuerto en Colombia.</p>\n",
        },
        {
            date: new Date("2026-03-01"),
            title: "Puerto Espacial en Rocha",
            subtitle: "Estudio arquitectos GVV",
            image: "rochagvv.png",
            type: "long",
            slug: "rocha-gvv",
            bodyHtml: "<p>Se continúan los desarrollos conceptuales del puerto espacial para Rocha, Uruguay, a través del trabajo en conjunto con el estudio de arquitectos García Vogliolo y Vitale. La propuesta integra criterios de funcionalidad técnica, sostenibilidad ambiental e inserción territorial, contemplando tanto las necesidades operativas como los componentes de vinculación con el entorno y la comunidad. Se hizo un diseño del sitio con las diversas áreas dedicadas, y la infraestructura asociada a cada una, con un nuevo plano de usos de suelos.</p>\n",
        },
        {
            date: new Date("2026-02-25"),
            title: "Expansión regional de contactos",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se consolida la red inicial de Cosmic Shores en la región, estableciendo lazos y puntos focales en Uruguay, Chile, Ecuador, Costa Rica, y República Dominicana.</p>\n",
        },
        {
            date: new Date("2026-02-06"),
            title: "The Cosmic Shores es incorporada",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se consolida la empresa a través de su conformación como corporación en el Estado de Florida, USA</p>\n",
        },
        {
            date: new Date("2025-10-20"),
            title: "Lineas estratégicas a nivel mundial",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Hoy en día se están estudiando distintas líneas estratégicas en distintas partes del mundo.</p>\n",
        },
        {
            date: new Date("2025-09-15"),
            title: "Ecuador",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se comenzó la exploración de actividades en Ecuador.</p>\n",
        },
        {
            date: new Date("2025-09-01"),
            title: "Incorporación de estudio GVV",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se incorpora al equipo el estudio de arquitectos García Vogliolo y Vitale, para avanzar con los desarrollos en infraestructura de espaciopuertos.</p>\n",
        },
        {
            date: new Date("2025-09-01"),
            title: "Puerto Espacial en Rocha",
            subtitle: "A través de colaboración con estudio HAL",
            image: "render-87.jpg",
            type: "long",
            slug: "puerto-espacial-rocha",
            bodyHtml: "<p>En septiembre de 2025 comenzamos a desarrollar un puerto espacial para el departamento de Rocha, Uruguay.</p>\n<p>El mismo tiene que adaptarse a diversos requerimientos y demandas edilicias del municipio, dado que existe una reserva natural cerca del sitio elegido.</p>\n<p>Se comenzó con la planificación del sitio, la estimación de la infraestructura mínima, lo que permitirá hacer un análisis de costos.</p>\n",
        },
        {
            date: new Date("2025-08-19"),
            title: "Participación en el 50 Aniversario CIDA-E",
            subtitle: "Cosmic Shores es invitado a Uruguay",
            image: "cida-e.png",
            type: "long",
            slug: "50-aniversario-cida-e",
            bodyHtml: "<p>Cosmic Shores participa en la reunión organizada por el Centro de Investigación y Difusión Aeronáutico Espacial de Uruguay, en su evento conmemorativo por sus 50 años.</p>\n<p>En esa reunión se hicieron contactos clave con referentes del sector en Uruguay.</p>\n",
        },
        {
            date: new Date("2025-01-01"),
            title: "Aliado estratégico",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se incorporó el Estudio HAL de Hugo A. Larotonda como un nuevo aliado estratégico.</p>\n",
        },
        {
            date: new Date("2024-12-01"),
            title: "Argentina",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se comenzó a explorar la posibilidad de poner en valor los puertos espaciales de Argentina.</p>\n",
        },
        {
            date: new Date("2024-06-01"),
            title: "Planificación",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se generaron el Plan Estratégico Empresarial (PEE) y el primer Plan General de Negocios (PGN).</p>\n",
        },
        {
            date: new Date("2024-05-01"),
            title: "Se funda Cosmic Shores SpacePorts",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Se elige el nombre de la empresa.</p>\n",
        },
        {
            date: new Date("2024-04-01"),
            title: "Nacimiento de la Idea",
            subtitle: "",
            image: "",
            type: "short",
            slug: "",
            bodyHtml: "<p>Surge como spin-off de WITMO y SOGi la idea de conformar una empresa vinculada a puertos espaciales.</p>\n",
        },
    ],
};

export default allBlogPosts;
